import { combineEpics } from "redux-observable";

import { epic as calendarEpic } from "./calendar";
import { dispatchEventEpic } from "./dispatcher";
import { fetchDropdownsEpic } from "./dropdowns";
import { epic as eventsEpic } from "./events";
import { updateJobEpic } from "./jobs";
import { epics as modalEpics } from "./modals";
import { epic as organizationEpic } from "./organization";
import {
  fetchAvailableBidsEpic,
  searchCustomersEpic as searchCustomersBidsEpic,
} from "./searchBids";
import { fetchAvailableJobsEpic, searchCustomersEpic } from "./searchJobs";
import { fetchAvailablePurchaseOrdersEpic } from "./searchPurchaseOrders";
import { epic as settingsEpic } from "./settings";
import { fetchStandardCrewsEpic } from "./standardCrews";
import { fetchTokenInfoEpic } from "./tokenInfo";
import { epics as workOrdersEpics } from "./workOrders";
import {
  fetchAvailableEmployeesEpic,
  searchEmployeessEpic,
} from "./searchEmployees";
import { fetchEquipmentsEpic } from "./equipments";
import {
  fetchAvailableAppointmentsEpic,
  searchCustomersEpic as searchAppointmentsCustomerEpic,
  searchDatasheetsEpic,
  searchJobsEpic,
} from "./searchAppointments";
import { fetchItemTypesEpic } from "./searchItemTypes";
import { handleItemTypesEpic } from "./settings";

export default combineEpics(
  calendarEpic,
  dispatchEventEpic,
  eventsEpic,
  fetchAvailableBidsEpic,
  fetchAvailableJobsEpic,
  fetchAvailablePurchaseOrdersEpic,
  fetchDropdownsEpic,
  fetchStandardCrewsEpic,
  fetchTokenInfoEpic,
  modalEpics,
  organizationEpic,
  searchCustomersBidsEpic,
  searchCustomersEpic,
  settingsEpic,
  updateJobEpic,
  workOrdersEpics,
  fetchAvailableEmployeesEpic,
  searchEmployeessEpic,
  fetchEquipmentsEpic,
  fetchAvailableAppointmentsEpic,
  searchAppointmentsCustomerEpic,
  searchDatasheetsEpic,
  searchJobsEpic,
  fetchItemTypesEpic,
  handleItemTypesEpic
);
